import React from 'react'
import './Contact.css';
import emailjs from '@emailjs/browser';
import { useRef } from 'react';
import { useState } from 'react';
import { themeContext } from '../../Context';
import { useContext } from 'react';
// yarn add emailjs
// yarn add @emailjs/browser
const Result =()=>{
    return(
        <p>Your message has been Successfully sent . I will contact you soon</p>
    )
}
const Contact = () => {
    const theme = useContext(themeContext)
    const darkMode = theme.state.darkMode
    const form = useRef();
    const [result ,showResult] = useState(false)
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_sh1zslo', 'template_4wgsvfe', form.current, 'oJ1htIvVGjX5JT9CU')
            .then((result) => {
                console.log(result.text)
            }, (error) => {
                console.log(error.text);
            });
            e.target.reset();
            showResult(true)
    };
    // Hide result
    setTimeout(()=>{
        showResult(false);
    },5000);
    return (
        <div className="contact-form" id="Contact-form">
            <div className="w-left">
                <div className="awesome">
                    <span style={{color: darkMode? 'white': ''}}>Get in touch</span>
                    <span>Contact me</span>
                </div>
                <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}>
                </div>
            </div>
            <div className="c-right">
                <form ref={form} onSubmit={sendEmail}>
                    <input type="text" name="user_name" className="user" placeholder="Name" required/>
                    <input type="email" name="user_email" className="user" placeholder="Email" required/>
                    <input type="text" name="user_number" className="user" placeholder="Phone Number" required/>
                    <input type="text" name="user_city" className="user" placeholder="Location{City}" required/>
                    <textarea name="message" className="user" placeholder="Message" required/>
                    <input type="submit" value="Send" className="button"/>
                    <span>{result ? <Result/> : null}</span>
                    <div className="blur c-blur1"
                    style={{ background: "var(--purple)" }}>
                    </div>
                </form>
            </div>
        </div>

    )
}

export default Contact
